import { pointerIntersection } from "@dnd-kit/collision";
import { useDroppable } from "@dnd-kit/react";

import {
  ITEM_MOVE_DRAG_TYPE,
  ITEM_MOVE_EXPAND_TARGET_TYPE,
} from "../item-move-dnd";

export function useItemMoveExpandTarget(id: string, disabled = false) {
  return useDroppable({
    id: `${ITEM_MOVE_EXPAND_TARGET_TYPE}:${id}`,
    type: ITEM_MOVE_EXPAND_TARGET_TYPE,
    collisionDetector: pointerIntersection,
    disabled,
    accept: ITEM_MOVE_DRAG_TYPE,
  });
}
